// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2p5QV","detailsBorder":"styles_detailsBorder__HMrYT"};